import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useReplacementList } from './api';
import styled from 'styled-components';
import { DeviceAction, ProductUpdateRole } from './enums';
import { Select } from '@purpurds/purpur/select';
import { RadioButtonGroup } from '@purpurds/purpur/radio-button-group';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import { purpurColorRed600 } from '@purpurds/tokens/color/variables';
import spacing from 'theme/spacing';
import { useMediaQuery } from 'utils/media-query';
const ProductPairContainer = styled.div `
  width: auto;
  display: flex;
  flex-direction: column;
  padding: 1rem 2rem 0;
`;
const ProductSelectPair = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;

  @media (max-width: 530px) {
    flex-direction: column;
  }
`;
const StyledSelect = styled(Select) `
  width: 300px;
`;
const ArrowRight = styled.div `
  padding: 0 1rem;

  @media (max-width: 530px) {
    padding: 0.5rem 0;
  }
`;
const DeviceActionSection = styled.div `
  display: flex;
  align-items: center;

  @media (max-width: 750px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
const DeviceActionText = styled.div `
  font-size: 20px;
  padding-right: 2rem;

  @media (max-width: 750px) {
    padding-bottom: 1rem;
  }
`;
const StyledIcon = styled(Icon) `
  margin-left: ${spacing.spacing8};
  color: ${purpurColorRed600};
  cursor: pointer;

  @media (max-width: 530px) {
    margin-top: ${spacing.spacing8};
  }
`;
export const ProductPair = ({ agreementId, options, pair, updateSelection, removePair, hasMultiplePairs, disabled, }) => {
    var _a, _b, _c;
    const isMobile = useMediaQuery({ query: `(max-width: 530px)` });
    const selectedProductId = ((_a = pair.source) === null || _a === void 0 ? void 0 : _a.value)
        ? Number(pair.source.value)
        : null;
    const { replacementList, isFetching, isLoading, replacementListError, } = useReplacementList(agreementId, selectedProductId);
    const optionsWithPlaceholder = [
        { value: '', label: 'Select...' },
        ...options,
    ];
    const deviceActionItems = [
        {
            id: 'return',
            label: DeviceAction.Return,
            value: DeviceAction.Return,
        },
        {
            id: 'transfer',
            label: DeviceAction.Transfer,
            value: DeviceAction.Transfer,
        },
    ];
    const mapReplacementList = (list) => {
        if (!list)
            return [];
        return list.map(item => ({
            value: String(item.id),
            label: item.name,
        }));
    };
    const replacementOptions = mapReplacementList(replacementList);
    const hasNoOptions = selectedProductId &&
        replacementOptions.length === 0 &&
        !isLoading &&
        !isFetching;
    return (_jsxs(ProductPairContainer, { children: [_jsxs(ProductSelectPair, { children: [_jsx(StyledSelect, { options: optionsWithPlaceholder, value: ((_b = pair.source) === null || _b === void 0 ? void 0 : _b.value) || '', loading: !optionsWithPlaceholder, onChange: (e) => {
                            const selectedValue = e.target.value;
                            const selectedOption = options.find(op => op.value === selectedValue);
                            if (!selectedOption)
                                return;
                            updateSelection(pair.id, ProductUpdateRole.Source, selectedOption);
                        }, disabled: disabled }), _jsx(ArrowRight, { children: _jsx(Icon, { svg: isMobile ? icons.arrowDown : icons.arrowRight, onClick: () => removePair(pair.id), size: 'md' }) }), _jsx(StyledSelect, { options: hasNoOptions
                            ? [{ value: '', label: 'No replacements available' }]
                            : [{ value: '', label: 'Select...' }, ...replacementOptions], value: ((_c = pair.target) === null || _c === void 0 ? void 0 : _c.value) || '', onChange: (e) => {
                            const selectedValue = e.target.value;
                            const selectedOption = replacementOptions.find(op => op.value === selectedValue);
                            if (!selectedOption)
                                return;
                            updateSelection(pair.id, ProductUpdateRole.Target, selectedOption);
                        }, loading: !!pair.source && (isFetching || isLoading), disabled: !pair.source || disabled }), hasMultiplePairs && (_jsx(StyledIcon, { svg: icons.remove, onClick: () => removePair(pair.id), size: 'md' }))] }), _jsxs(DeviceActionSection, { children: [_jsx(DeviceActionText, { children: " Hva skal skje med enheten? " }), _jsx(RadioButtonGroup, { id: "device-action-radio-button", items: deviceActionItems, onValueChange: (value) => {
                            updateSelection(pair.id, ProductUpdateRole.DeviceAction, value);
                        }, value: pair.deviceAction, orientation: isMobile ? "vertical" : "horizontal" })] })] }, pair.id));
};
